import { Component, Prop, Ref} from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LoyaltyCircleRewards extends ThemeComponent {
    @Prop customer!: boolean;

    // init() {
    //     if(!this.images) {
    //         return;
    //     }

    //     const target = document.querySelector('div[data-lion-rewards-list]') as HTMLElement;
    //     const config = { childList: true };

    //     const observer = new MutationObserver(() => {
    //         if (document.querySelector('.lion-rewards-list')) {
    //             // this.process();
    //             const rewardIcons = this.querySelectorAll('.lion-reward-item__icon');
    //             this.renderImages(rewardIcons);
    //             observer.disconnect();
    //         }
    //     });

    //     observer.observe(target, config);

    //     const claimedTarget = document.querySelector('div[data-lion-claimed-rewards-list]') as HTMLElement;
    //     const claimedConfig = { childList: true };

    //     const claimedObserver = new MutationObserver(() => {
    //         if (document.querySelector('.lion-claimed-rewards-list')) {
    //             // this.process();
    //             const ruleIcons = this.querySelectorAll('.lion-claimed-reward-item__icon');
    //             this.renderImages(ruleIcons);
    //             claimedObserver.disconnect();
    //         }
    //     });

    //     claimedObserver.observe(claimedTarget, claimedConfig);
    // }

    // claimedProcess() {

    // }

    // process() {
    //     let icons;
    //     const rewardIcons = this.querySelectorAll('.lion-reward-item__icon');
    //     const ruleIcons = this.querySelectorAll('.lion-rule-item__icon');

    //     this.$log.info('icons rewards', rewardIcons);
    //     this.$log.info('icons rule', ruleIcons);

    //     if (rewardIcons && rewardIcons.length > 0) {
    //         icons = rewardIcons;
    //     } else if (ruleIcons && ruleIcons.length > 0) {
    //         icons = ruleIcons;
    //     }

    //     // if (!icons || !icons.length) {
    //     //     return;
    //     // }

    //     // for (const [i, icon] of icons.entries()) {
    //     //     const imageEl = document.createElement('img');
    //     //     imageEl.src = this.images[i];
    //     //     imageEl.style.width = `${this.sizes[i]}px`;
    //     //     icon.append(imageEl);
    //     // }

    // }

    // renderImages(icons: NodeListOf<Element>) {
    //     if (!icons || !icons.length) {
    //         return;
    //     }

    //     for (const [i, icon] of icons.entries()) {
    //         const imageEl = document.createElement('img');
    //         imageEl.src = this.images[i];
    //         imageEl.style.width = `${this.sizes[i]}px`;
    //         icon.append(imageEl);
    //     }
    // }
}

